import { render } from "./FlexMessageBubbleTree.vue?vue&type=template&id=3831d694&scoped=true"
import script from "./FlexMessageBubbleTree.vue?vue&type=script&lang=ts"
export * from "./FlexMessageBubbleTree.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-3831d694"

export default script
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
